import React, { ReactNode } from "react";
import * as Styled from "./RichTextParagraph.styled";

const RichTextParagraph: React.FC<{ children: ReactNode }> = ({ children }) => {
  return <Styled.Paragraph>{children}</Styled.Paragraph>;
};

export default RichTextParagraph;
